/////////////////////// INJECTION SHOP INFOS

const SHOP_NAME = window.SHOP_NAME;
const SHOP_URL = window.SHOP_URL;

const COMPANY_NAME = window.COMPANY_NAME;
const COMPANY_ADDRESS = window.COMPANY_ADDRESS;
const COMPANY_COUNTRY = window.COMPANY_COUNTRY;
const COMPANY_RC = window.COMPANY_RC;
const COMPANY_VAT = window.COMPANY_VAT;
const COMPANY_CAPITAL = window.COMPANY_CAPITAL;
const SHOP_URL2 = window.SHOP_URL2;
const CONTACT_EMAIL = window.CONTACT_EMAIL;

document.addEventListener("DOMContentLoaded", function () {
  const replacements = {
    "\\[SHOP_NAME\\]": SHOP_NAME,
    "\\[SHOP_URL\\]": SHOP_URL,
    "\\[COMPANY_NAME\\]": COMPANY_NAME,
    "\\[ADDRESS\\]": COMPANY_ADDRESS,
    "\\[COUNTRY\\]": COMPANY_COUNTRY,
    "\\[RC\\]": COMPANY_RC,
    "\\[VAT\\]": COMPANY_VAT,
    "\\[CAPITAL\\]": COMPANY_CAPITAL,
    "\\[SHOP_URL2\\]": SHOP_URL2,
    "\\[EMAIL\\]": CONTACT_EMAIL,
  };

  const el = document.getElementById("auto-shop-url");
  if (el && SHOP_URL) {
    el.href = SHOP_URL;
    el.textContent = SHOP_URL.replace(/^https?:\/\//, "");
  }

  const targets = document.querySelectorAll(
    "main, .rte, .page-width, .shopify-section"
  );

  targets.forEach((targetElement) => {
    // TreeWalker est la méthode la plus sûre pour parcourir les nœuds de texte
    const walker = document.createTreeWalker(
      targetElement,
      NodeFilter.SHOW_TEXT
    );
    let currentNode;
    const nodesToReplace = [];

    // On parcourt tous les nœuds de texte
    while ((currentNode = walker.nextNode())) {
      // On vérifie si le texte contient un placeholder et qu'il ne s'agit pas d'un script ou d'un style
      if (
        currentNode.nodeValue.includes("[") &&
        currentNode.parentElement.tagName !== "SCRIPT" &&
        currentNode.parentElement.tagName !== "STYLE"
      ) {
        nodesToReplace.push(currentNode);
      }
    }

    // On modifie uniquement les nœuds de texte qui contiennent des placeholders
    nodesToReplace.forEach((node) => {
      let text = node.nodeValue;
      for (const placeholder in replacements) {
        if (new RegExp(placeholder, "g").test(text)) {
          text = text.replace(
            new RegExp(placeholder, "g"),
            replacements[placeholder]
          );
        }
      }
      node.nodeValue = text;
    });
  });
});
